import { FormEvent, useState } from 'react';
import { api, ApiError } from '../api/client';

type Props = { onLogin: () => void };

export default function LoginPage({ onLogin }: Props) {
  const [passphrase, setPassphrase] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (loading) return;
    setError(null);
    setLoading(true);
    try {
      await api.post('/api/v1/auth/login', { passphrase });
      onLogin();
    } catch (err) {
      if (err instanceof ApiError && err.code === 'INVALID_PASSPHRASE') {
        setError('Passphrase non corretta.');
      } else if (err instanceof ApiError && err.status === 429) {
        setError('Troppi tentativi. Riprova tra un minuto.');
      } else {
        setError('Errore, riprova.');
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="relative flex min-h-[100svh] items-center justify-center px-6 py-14">
      <div className="pointer-events-none absolute -top-10 -left-10 h-64 w-64 rounded-full blur-3xl opacity-70"
        style={{ background: 'radial-gradient(closest-side,#FCE8E5,transparent)' }} aria-hidden />
      <div className="pointer-events-none absolute -bottom-20 -right-16 h-80 w-80 rounded-full blur-3xl opacity-60"
        style={{ background: 'radial-gradient(closest-side,#FDF0D1,transparent)' }} aria-hidden />

      <form onSubmit={onSubmit} className="w-full max-w-sm relative" autoComplete="off">
        <header className="text-center mb-10 animate-riseIn">
          <div className="mx-auto mb-6 h-20 w-20 rounded-3xl shadow-card flex items-center justify-center text-5xl"
            style={{ background: 'linear-gradient(135deg,#FFD4C2,#F3856F)' }}
            aria-hidden>
            🍝
          </div>
          <h1 className="text-4xl font-extrabold tracking-tightest text-ink">
            Ricettario <span className="text-brand">Caluzzelli</span>
          </h1>
          <p className="text-muted mt-2">Il ricettario di famiglia.</p>
        </header>

        <div className="card p-6 animate-riseIn" style={{ animationDelay: '80ms' }}>
          <label htmlFor="passphrase" className="block text-sm font-semibold text-ink mb-2">
            Parola d'ordine
          </label>
          <input
            id="passphrase"
            type="password"
            className="input-bring text-lg"
            value={passphrase}
            onChange={(e) => setPassphrase(e.target.value)}
            autoFocus
            autoCapitalize="off"
            autoCorrect="off"
            spellCheck={false}
            placeholder="la tua passphrase"
            required
          />
          {error && <p className="text-brand text-sm mt-3 font-medium">{error}</p>}

          <button
            type="submit"
            className="btn-brand w-full mt-5"
            disabled={loading || !passphrase}
          >
            {loading ? 'verifica…' : 'Entra'}
          </button>
        </div>

        <p className="text-xs text-muted text-center mt-8 animate-riseIn" style={{ animationDelay: '160ms' }}>
          cucinato con <span className="text-brand">♥</span> per i Caluzzelli
        </p>
      </form>
    </main>
  );
}
